export default __webpack_public_path__ + "static/media/win.85cfe4e2.png";